import React from 'react';
import { type StyleProp, StyleSheet, type TextStyle, View } from 'react-native';

import { AnimatedNumberText, BodyText, theme } from '@sg/garnish';

export const CustomizationFooterText = (props: Props) => {
  const { productName, price, calories, style } = props;

  const textStyles = [styles.text, style];

  return (
    <View style={styles.container}>
      <View style={styles.summary}>
        <BodyText sizeMatch={['24']} style={textStyles}>
          {productName}
        </BodyText>

        <BodyText sizeMatch={['24']} style={textStyles}>
          {' • '}
        </BodyText>

        <AnimatedNumberText.BodyText
          text={price}
          animateInitialValue={false}
          duration={VALUE_ANIMATION_DURATION}
          sizeMatch={['24']}
          style={textStyles}
        />

        <BodyText sizeMatch={['24']} style={textStyles}>
          {' • '}
        </BodyText>

        <AnimatedNumberText.BodyText
          text={calories}
          animateInitialValue={false}
          duration={VALUE_ANIMATION_DURATION}
          sizeMatch={['24']}
          style={textStyles}
        />
      </View>
    </View>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────

const VALUE_ANIMATION_DURATION = 1_000;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  summary: {
    flexDirection: 'row',
    alignItems: 'baseline',
    flexWrap: 'wrap',
  },
  text: {
    color: theme.colors.DARK_KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  productName: string;
  price: string;
  calories: string;
  style?: StyleProp<TextStyle>;
};
